<template>
  <div class="bg-F6F6F6 height-full fb fb-col">
    <div class="bg-FFFFFF">
      <md-tabbar
        class="mb-8"
        v-model="tabIndex"
        indicatorColor="#171A1D"
        :fixed="list.length < 4"
      >
        <md-tabbar-item
          v-for="item in list"
          :key="item.leaveType"
          :name="item.leaveType"
        >
          {{ item.leaveTypeName }}
          {{ item.notShow ? '' : `(${item.count || 0})` }}
        </md-tabbar-item>
      </md-tabbar>
      <md-tabbar
        v-if="subList.length"
        class="bt sub-tabbar"
        v-model="subTabIndex"
        indicatorColor="#171A1D"
        :fixed="subList.length < 3"
      >
        <md-tabbar-item
          v-for="item in subList"
          :key="item.subLeaveTypeId"
          :name="item.subLeaveTypeId"
          :class="[item.subLeaveTypeId === subTabIndex ? 'active' : '']"
        >
          {{ item.subLeaveTypeName }}
          {{ item.notShow ? '' : `(${item.count || 0})` }}
        </md-tabbar-item>
      </md-tabbar>
    </div>
    <div
      class="item-flex-1 scroll m-0-16"
      @scroll="handlerLoadingMore"
      v-if="(detailList || []).length"
    >
      <div
        class="bg-FFFFFF bd-radio-8 m-12-0 font-28 hidden"
        v-for="(item, index) in detailList"
        :key="index"
      >
        <div class="c-171A1D-56 lh-20 p-8-0 pl-16 pt-12">{{
          item.className
        }}</div>
        <leave-list-item
          class="bb"
          no-pb
          has-tag
          :student="student"
          v-for="student in item.studentLeaveList"
          :key="student.leaveId"
          @click="handlerClickItem"
          @clickBack="handlerClickBack"
        ></leave-list-item>
      </div>
    </div>
    <div v-else class="w-fullVw item-flex-1 relative" style="min-height: 216px">
      <common-no-data class="no-record">
        <div class="no-item"></div>
        <p class="font-28 c-171A1D-40">当天暂无记录</p>
      </common-no-data>
    </div>
  </div>
</template>

<script>
import commonNoData from '../commonNoData'
import leaveListItem from './leaveListItem'
import { BACK_SCHOOL_STATUS } from '@/utils/constUtils'
import { timeFormat, unitDayTime } from '@/utils/comUtils'
import mixin from '@/mixin'
import API from '@/api'
export default {
  mixins: [mixin],
  name: '',
  components: { commonNoData, leaveListItem },
  props: {
    dimDay: {
      type: String,
      default: timeFormat(new Date(), 'YYYY-MM-DD')
    },
    list: {
      type: Array,
      default: () => []
    },
    stateId: {
      type: [String, Number],
      default: ''
    }
  },
  data() {
    return {
      BACK_SCHOOL_STATUS,
      timeFormat,
      unitDayTime,
      tabIndex: +this.stateId || 0,
      subTabIndex: '',
      subList: [],
      tabObj: {},
      tagIndex: '',
      detailList: [],
      isLoadDetailMore: true,
      pageNum: 1,
      pageSize: 10,
      noNeedCheckStatus: '',
      isInit: true,
      showLoading: null
    }
  },
  computed: {
    allowLeaveBackCertificate() {
      return this.$store.getters.allowLeaveBackCertificate
    },
    cpTabIndex() {
      return `${this.tabIndex}-${this.subTabIndex}`
    }
  },
  watch: {
    dimDay() {
      !this.isInit && this.initTabList()
    },
    tabIndex: {
      deep: true,
      immediate: true,
      handler(val) {
        this.subList = []
        this.$nextTick(() => {
          this.subList =
            this.list.filter(item => item.leaveType === val)[0]
              .subLeaveTypeList || []
          this.subTabIndex = ''
        })
        console.log(val, this.subList)
      }
    },
    cpTabIndex() {
      this.handlerChangeState(
        this.list.find(item => +item.leaveType === +this.tabIndex),
        false,
        true,
        true
      )
    }
  },
  beforeCreate() {},
  created() {},
  beforeMount() {},
  mounted() {
    this.showLoading = this.$Toast({
      type: 'loading',
      duration: 9000,
      content: '加载中···'
    })
    setTimeout(() => {
      this.isInit = false
      this.initTabList()
    }, 100)
  },
  beforeUpdate() {},
  updated() {},
  activated() {},
  deactivated() {},
  beforeDestroy() {},
  destroyed() {},
  methods: {
    // 初始化tab
    initTabList() {
      let _tabId = this.list.map(item => {
        return +item.leaveType
      })
      this.tabIndex = _tabId.includes(+this.tabIndex)
        ? this.tabIndex
        : _tabId[0]
      this.handlerChangeState(
        {
          leaveType: this.tabIndex,
          subTabIndex: this.subTabIndex,
          subList: this.subList
        },
        false,
        true
      )
    },
    // 切换状态 (状态，是否是滚动，是否是初始化, 初始化标签)
    handlerChangeState(state, isScroller, initPage, initTag) {
      initPage && (this.pageNum = 1) && (this.detailList = [])
      initTag && (this.tagIndex = '')
      this.showLoading.show()
      let params = {
        ...this.commonParams,
        dimDay: this.dimDay,
        pageNum: this.pageNum,
        pageSize: this.pageSize
      }
      state.leaveType && (params.leaveType = state.leaveType)
      this.subTabIndex && (params.subLeaveTypeId = this.subTabIndex)
      API.getLeaveDayStatDetail(params)
        .then(res => {
          this.tabIndex = state.leaveType
          const _detailList = (res || {}).classLeaveList || []
          if (_detailList.length < this.pageSize) {
            this.isLoadDetailMore = false
          } else {
            ++this.pageNum
            this.isLoadDetailMore = true
          }
          this.detailList = isScroller
            ? this.detailList.concat(_detailList)
            : _detailList
        })
        .catch(err => {
          console.log('unhandledrejection', err)
        })
        .finally(_ => this.showLoading && this.showLoading.hide())
    },
    // 加载更多
    handlerLoadingMore(e) {
      let _el = e.currentTarget
      if (
        _el.scrollTop + _el.clientHeight >= _el.scrollHeight - 20 &&
        this.isLoadDetailMore
      ) {
        this.isLoadDetailMore = false
        this.handlerChangeState({ leaveType: this.tabIndex }, true, false)
      }
    },
    // 切换标签
    handlerChangeTag(item) {
      this.tagIndex = item.leaveType
      this.initTabList()
    },
    getSegTime(startTime, endTime, leaveDurationUnit) {
      if (leaveDurationUnit === 1) {
        return [
          timeFormat(new Date(startTime), 'MM.DD hh:mm'),
          timeFormat(new Date(endTime), 'MM.DD hh:mm')
        ]
      } else {
        return unitDayTime(startTime, endTime, 'YYYY.MM.DD hhmm')
      }
    },
    handlerClickItem(item) {
      this.$emit('click', item)
    },
    handlerClickBack(url, studentDingIds, leaveId) {
      this.$emit('clickBack', url, studentDingIds, leaveId)
    }
  }
}
</script>

<style lang="scss" scoped>
:deep(.sub-tabbar .md-tabbar__content) {
  .md-tabbar__item {
    color: rgba(23, 26, 29, 0.6);
    background: rgba(126, 134, 142, 0.16);
    margin: 6px;
    padding: 4px 10px;
    border-radius: 8px;
    &.active {
      color: #171a1d;
      background: rgba(126, 134, 142, 0.4);
    }
  }
  .md-tabbar__indicator {
    display: none;
  }
}
.scroll-x {
  overflow-x: scroll;
}
.no-record {
  .no-item {
    width: 180px;
    height: 180px;
    background: url(~@/assets/images/no-data.png) no-repeat center center;
    background-size: 100% 100%;
  }
}
</style>
